exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Checkbox__label{display:inline-block}.Checkbox__checkbox,.Checkbox__label{cursor:pointer}.Checkbox__itemText{margin-left:3px;position:relative;top:-2px;vertical-align:middle}", ""]);

// Exports
exports.locals = {
	"label": "Checkbox__label",
	"checkbox": "Checkbox__checkbox",
	"itemText": "Checkbox__itemText"
};